module.exports = __webpack_public_path__ + "static/media/menu.69541652.svg";